// extracted by mini-css-extract-plugin
module.exports = {"link":"_3ezsJ","emptyStateLink":"_2IA2X"};